var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurrentLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.41095C9.2 7.41095 7.31818 9.29277 7.31818 11.5928C7.31818 13.8928 9.2 15.7746 11.5 15.7746C13.8 15.7746 15.6818 13.8928 15.6818 11.5928C15.6818 9.29277 13.8 7.41095 11.5 7.41095ZM20.8045 10.5473C20.2818 6.15641 16.8318 2.70641 12.5455 2.28823V0.0927734H10.4545V2.28823C6.06364 2.70641 2.61364 6.15641 2.19545 10.5473H0V12.6382H2.19545C2.71818 17.0291 6.16818 20.4791 10.4545 20.8973V23.0928H12.5455V20.8973C16.9364 20.3746 20.3864 16.9246 20.8045 12.6382H23V10.5473H20.8045ZM11.5 18.911C7.42273 18.911 4.18182 15.67 4.18182 11.5928C4.18182 7.5155 7.42273 4.27459 11.5 4.27459C15.5773 4.27459 18.8182 7.5155 18.8182 11.5928C18.8182 15.67 15.5773 18.911 11.5 18.911Z",
    fill: "#F92972"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationIcon);
export default __webpack_public_path__ + "static/media/CurrentLocationIcon.f01b066d3f09f859d9e88a70a68f0a52.svg";
export { ForwardRef as ReactComponent };